<template>
  <div>
    <slot></slot>
    <ul class="pagination" :class="paginationClass" v-if="data.last_page !== 1">

      <li v-for="link in elements" :class="'page-item' + (link.active ? ' active' : '')">
        <a v-if="link.url" class="page-link" @click.prevent="changePage(link.page)" v-html="link.label"></a>
        <span v-else class="page-link" v-html="link.label"></span>
      </li>

    </ul>
  </div>
</template>

<script>
export default {

  emits: ['page-changed'],

  props: {
    data: {
      type: Object,
      default: () => {return {"links":[]};}
    },
    paginationClass: {
      type: String,
      default: 'justify-content-center'
    }
  },

  computed: {
    elements() {
      let elements = [];

      if (this.data.links) {
        this.data.links.forEach(link => {
          let element = link;

          element.label = (element.label === '&laquo; Previous') ? '&laquo;' : element.label;
          element.label = (element.label === 'Next &raquo;') ? '&raquo;' : element.label;

          element.page = 1;
          if (element.url) {
            element.page = element.url.match(/\?page=([\d]+)$/i)[1];
          }

          elements.push(element);
        });
      }

      return elements;
    },
  },

  methods: {
    changePage(page) {
      this.$emit('page-changed', page)
    }
  }
}
</script>
